export const Treatment = {
    template: `
        <ng-transclude ng-if="$ctrl.isTreatmentSelected()"></ng-transclude>
    `,
    bindings: {
        treatmentKey: '@',
        default: '@?'
    },
    require: {
        experiment: '^experiment'
    },
    transclude: true,
    controller: class {
        constructor() {
            'ngInject';
        }

        $onInit() {
            this.treatment = { selected: false };
            this.default = Boolean(this.default) || this.default !== undefined;
        }

        $postLink() {
            this.treatment.treatmentKey = this.treatmentKey;
            this.treatment.default = this.default;
            this.experiment.addTreatment(this.treatment);
        }

        isTreatmentSelected() {
            return this.treatment.selected;
        }
    }
};
